import React from "react";
import { PopupButton } from "react-calendly";
import './Calendly.css';

const Calender = () => {
  return (
    <div className="App">
      <PopupButton
        url="https://calendly.com/sarahfloresnutre"
        /*
         * react-calendly uses React's Portal feature (https://reactjs.org/docs/portals.html) to render the popup modal. As a result, you'll need to
         * specify the rootElement property to ensure that the modal is inserted into the correct domNode.
         */
        rootElement={document.getElementById("root")}
        text='Schedule Appointment'
        
        
      />

    </div>
  );
};

export default Calender;